<template>
  <li @click="closeContext" @contextmenu="closeContext" v-if="show">
    <div @contextmenu.prevent="openContext($event,index)" :class="{bold: isFolder}">
      <span @click="select" @dblclick="doubleClickedSelect" v-if="!editMode">
        <span v-for="(item,index) in options.fields" :key="index" class="noselect">
          {{ model[index]+'&nbsp;&nbsp;' }}
        </span>
      </span>
      <input
        v-if="editMode"
        @keyup="updateNode($event)"
        v-for="(item,index) in options.fields"
        :key="index"
        class="form-control tree-input"
        type="item.type"
        :placeholder="item.title"
        v-model="model[index]"
      >
      <span v-if="isFolder" @click="changeType" class="mr-1 noselect">[{{ open ? '-' : '+' }}]</span>
    </div>
    <ul v-show="open" v-if="isFolder||addMode" class="bd-tree-node">
      <li class="add input-li mb-1" @keyup="addChild($event)" v-if="addMode">
        <input
          v-for="(item,index) in options.fields"
          :key="index"
          class="form-control tree-input"
          type="item.type"
          :placeholder="item.title"
          v-model="node[index]"
        >
      </li>
      <bd-tree-node
        class="item"
        v-for="(model, index) in model.children"
        @add="add"
        @update="update"
        @deleteNode="deleteNode"
        :index="index+1"
        :key="index"
        :model="model"
        :options="options"
        :data="data"
      ></bd-tree-node>
    </ul>
    <context-menu
      v-if="options.access.add||options.access.edit||options.access.delete"
      id="context-menu"
      class="contextmenu"
      ref="ctxmenu"
      @ctx-open="onCtxOpen">
      <ul>
        <li @click="addToRoot" v-if="options.access.add">
          افزودن به ریشه
        </li>
        <!--<li @click="addBefore($event)">افزودن قبل از گره</li>-->
        <!--<li @click="addAfter($event)">افزودن بعد از گره</li>-->
        <li @click="addUnder($event)" v-if="options.access.add">افزودن فرزند</li>
        <li @click="editNode($event)" v-if="options.access.edit">ویرایش گره</li>
        <li @click="deleteNode(model)" v-if="options.access.delete">حذف گره</li>
      </ul>
    </context-menu>

  </li>
</template>

<script>
  import Vue from "vue";
  import BaseService from "../_framework/api/BaseService.js";
  import contextMenu from "vue-context-menu";
  import EventBus from "../bus.js";

  import * as $ from "jquery";

  export default {
    name: "bd-tree-node",
    components: {
      contextMenu
    },
    props: {
      options: Object,
      model: Object,
      index: 0,
      pIndex: Number,
      data: null
    },
    data: function () {
      return {
        show: true,
        isSelected: false,
        node: {},
        code: null,
        addMode: false,
        editMode: false,
        open: false,
        count: 0
      };
    },
    computed: {
      isFolder: function () {
        return this.model.children && this.model.children.length;
      }
    },
    mounted() {
    },
    watch: {},
    methods: {
      refresh() {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
      },
      openContext(e, index) {
        if (this.options.access.add || this.options.edit || this.options.delete) {
          setTimeout(() => {
            this.$refs.ctxmenu.open(e);
          }, 50);
        }
      },
      closeContext(e) {
        $(document.getElementsByClassName("contextmenu")).hide();
        if (this.$refs.ctxmenu) {
          this.$refs.ctxmenu.ctxVisible = false;
        }
      },
      select(e) {
        $(document)
          .find(".selected")
          .removeClass("selected");
        $(e.target.parentElement).addClass("selected");
        this.isSelected = !this.isSelected;
        let pId = this.model.parentId;
        let ancestors = [];
        while (pId) {
          let node = this.findById(pId);
          ancestors.push(node);
          pId = node.parentId;
        }
        this.model.ancestors = ancestors;
        EventBus.$emit("selectTreeNode", this.model);
      },
      findById(id) {
        let item = this.data.find(d => {
          return d.id === id;
        });
        return item;
      },
      doubleClickedSelect(e) {
        if (this.model[this.options.levelLabel] === this.options.levelLimit) {
          EventBus.$emit("doubleClickedSelect");
        }
      },
      onCtxOpen(e) {
      },
      addToRoot: function (e) {
        EventBus.$emit("rootInsert");
      },
      addBefore: function (e) {
      },
      addAfter: function (e) {
      },
      addUnder: function (e) {
        if (
          this.options &&
          this.options.levelLabel &&
          this.options.levelLimit &&
          this.model &&
          this.model[this.options.levelLabel] > this.options.levelLimit - 1
        ) {
          return;
        }
        $(document)
          .find(".input-li")
          .hide();
        let inputLi = $(
          e.target.parentElement.parentElement.parentElement.parentElement
        ).find(".input-li");
        // let inputLi = $(
        //   e.target.parentElement.parentElement.parentElement.parentElement.getElementsByClassName(
        //     "bd-tree-node"
        //   )
        // ).find(".input-li");
        setTimeout(() => {
          $(inputLi.first()).show();
        }, 50);
        this.addMode = true;
        if (!this.model.children) {
          Vue.set(this.model, "children", []);
        }
        this.open = true;
      },
      editNode: function (e) {
        this.editMode = true;
      },
      updateNode: function (e) {
        if (e.key === "Enter" || e.key === "Escape") {
          this.editMode = false;
          this.update(this.model);
        }
      },
      deleteNode: function (e) {
        this.$emit("deleteNode", e);
      },
      toggle: function () {
        if (this.isFolder) {
          this.open = !this.open;
        }
      },
      changeType: function (e) {
        this.toggle();
      },
      addChild: function (e) {
        if (e && e.key === "Enter") {
          // EventBus.$emit("add", this.node, this.model.id);
          this.add(this.node, this.model.id);
          this.node = {};
        }
      },
      add: function (node, id) {
        this.$emit("add", node, id);
      },
      update: function (data) {
        this.$emit("update", data);
      }
    }
  };
</script>

<style scoped>
  .selected {
    background-color: rgba(0, 0, 0, 0.2);
    color: white;
    padding: 0 5px;
    border-radius: 4px;
  }

  .tree-input {
    width: 130px;
    height: 25px;
    display: inline-flex;
    margin-left: 1em;
  }

  .bold {
    font-weight: bold;
  }

  #context-menu li {
    text-align: right;
  }

  #context-menu li:hover {
    background-color: cornflowerblue;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                     supported by Chrome and Opera */
  }
</style>

